import { getCookie, setCookie, deleteCookie } from "../modules/cookies_ex";

export function subscribeExt($diff) {

    function actionSubscribeScroll(diff){
        if($('.subscribe-scroll-wrp').length > 0) {
            var subscribe_form = $('.subscribe-form');
            var subscribe_form_2 = $('.subscribe-scroll-wrp');
            var footer = $('footer');
            var offset_footer = footer[0].offsetTop;
            var height_footer = footer[0].offsetHeight;
            var offset_top = subscribe_form[0].offsetTop;
            var offset_height = subscribe_form[0].offsetHeight;
            var offset_top2 = subscribe_form_2[0].offsetTop;
            var offset_height2 = subscribe_form_2[0].offsetHeight;

            $(window).on('scroll', function () {
                if (window.pageYOffset > (offset_footer - (offset_height + offset_height2 + height_footer + diff))) {
                    $('.subscribe-scroll-wrp').addClass('hide-subscribe');
                } else {
                    $('.subscribe-scroll-wrp').removeClass('hide-subscribe');
                }

                /*console.log({
                    offset : offset_top2,
                    height : offset_height,
                    height2 : offset_height2,
                    f_offset : offset_footer,
                    f_height : height_footer,
                    window_scroll: window.pageYOffset,
                    hide_subscribe: (window.pageYOffset > (offset_footer - (offset_height + offset_height2 + diff)))
                });

                console.log(getCookie('user111'));
                deleteCookie('user111');
                console.log(getCookie('user111'));
                */
            });
        }
    }

    function actionHideOnClick(){
        $(document).on('click', '.close-subscribe-scroll', function () {
            setCookie('afisha_already_subscribed', 1, {secure: true, 'max-age': 3600});
            $('.subscribe-scroll-wrp').addClass('hide-subscribe-on-click');
        });
    }

    function actionOpenSuccessPopUp() {
        var popup_html = '';
        popup_html += '<div class="mc-subscribe-success-popup-wrp">';
        popup_html += '<div class="mc-subscribe-success-popup">';
        popup_html += '<span class="close-mc-subscribe-success-popup">×</span>';
        popup_html += '<p>' + revent_data.subscribe_success + '</p>';
        popup_html += '</div>';
        popup_html += '</div>';

        $(document).ready(function ($) {

            if ($('body').hasClass('mc_subscribe_success')) {

                $('.subscribe-scroll-wrp').addClass('hide-subscribe-on-click');
                setCookie('afisha_already_subscribed', 1, {secure: true, 'max-age': 3600});

                $('body').append(popup_html);

                $('body,html').animate({
                    scrollTop: $(".subscribe-form").offset().top
                }, 1000).addClass('scroll_disabled');

                $('.close-mc-subscribe-success-popup').on('click', function () {
                    $('body,html').removeClass('scroll_disabled');
                    $(document).find('.mc-subscribe-success-popup-wrp').remove();

                    var clean_uri = location.protocol + "//" + location.host + location.pathname;
                    window.history.replaceState({}, document.title, clean_uri);
                });
            }
        });
    }

    actionHideOnClick();
    actionOpenSuccessPopUp();
    actionSubscribeScroll($diff);
}


// WEBPACK FOOTER //
// ./assets/js/modules/subscribe.js